import { editDeviceCalibrateResultRequest, getDeviceCalibrateResultRequest } from "@/service/parameterConfiguration";
import { Button, Col, Divider, Form, Input, InputNumber, Row, message } from "antd";
import { useEffect, useState } from "react";

interface iProps {
    id: number | string,
    sn: number | string,
    refreshTrigger?: number,
    onRefreshAll?: () => void
}

const CameraYzyForm = (props: iProps) => {

    const { id, sn, refreshTrigger, onRefreshAll } = props
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearch, setHasSearch] = useState(false);


    const updateForm = async () => {
        let _formValue = {};
        try {
            setIsLoading(true);
            const res = await getDeviceCalibrateResultRequest({ id, sn });
            const data = res.data?.data || {};

            const parseNumber = (v: any) => (v === null || v === undefined || v === '' ? undefined : Number(v));

            _formValue = {
                version: data.version,
                success: parseNumber(data.success),
                frontTireWidth: parseNumber(data.frontTireWidth),
                rearAxleToFrontBumper: parseNumber(data.rearAxleToFrontBumper),
                wheelbase: parseNumber(data.wheelbase),
                cameraFrontBumperDistance: parseNumber(data.cameraFrontBumperDistance),
                cameraCenterOffset: parseNumber(data.cameraCenterOffset),
                cameraHeight: parseNumber(data.cameraHeight),
                cameraLateralDeviation: parseNumber(data.cameraLateralDeviation),
                calibrationBoardCenterHeight: parseNumber(data.calibrationBoardCenterHeight),
                locationX: parseNumber(data.locationX),
                locationY: parseNumber(data.locationY),
                locationZ: parseNumber(data.locationZ),
                pitch: parseNumber(data.pitch),
                yaw: parseNumber(data.yaw),
                roll: parseNumber(data.roll),
            };
            setHasSearch(true);
        } catch (err) {
            console.error("err", err);
        } finally {
            setIsLoading(false);
            form.setFieldsValue(_formValue);
        }

    }
    useEffect(() => {
        updateForm();
    }, [id, sn, refreshTrigger]);


    const submitForm = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();
            const params = {
                id,
                ...values
            }
            params.cameraLateralDeviation = 0; // 废弃字段，传一个默认值
            const res = await editDeviceCalibrateResultRequest(params, sn);
            
            if (res.data.code === 0) {
                message.success('下发相机标定结果成功');
                // 提交成功后通知所有表单刷新
                onRefreshAll?.();
            } else {
                message.error('下发相机标定结果失败');
            }
        } catch (error) {
            console.error("submit failed:", error);
            message.error('下发相机标定结果失败');
        } finally {
            setIsLoading(false);
        }
    }

    return <div>
        <Divider>相机标定结果</Divider>
        <Form form={form} labelAlign="left" labelCol={{ span: 6, style: { whiteSpace: 'normal', overflowWrap: 'break-word' } }} wrapperCol={{ span: 14 }}>
            <Form.Item label="参数版本号" name="version" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item label="标定状态" name="success" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="车宽(前轮胎外边缘距离)(单位:毫米)" name="frontTireWidth" style={{ marginBottom: '20px' }} >
                <InputNumber style={{ width: '100%' }} disabled={true}/>
            </Form.Item>
            <Form.Item label="后轴到前保的距离(单位:毫米)" name="rearAxleToFrontBumper" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} disabled={true}/>
            </Form.Item>
            <Form.Item label="轴距(单位:毫米)" name="wheelbase" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} disabled={true}/>
            </Form.Item>
            <Form.Item label="摄像头到前保的纵向距离(负值)(单位:米)" name="cameraFrontBumperDistance" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="摄像头中线距离左正右负(单位:米)" name="cameraCenterOffset" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="摄像头到地面距离(单位:米)" name="cameraHeight" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            {/* <Form.Item label="摄像头相对横向偏差左正右负(单位:毫米)" name="cameraLateralDeviation" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item> */}
            <Form.Item label="标定板图案中心高度(单位:米)" name="calibrationBoardCenterHeight" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置x" name="locationX" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置y" name="locationY" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后位置z" name="locationZ" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后pitch" name="pitch" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后yaw" name="yaw" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定后roll" name="roll" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <div style={{ textAlign: 'right' }}>
                <Button
                    type="primary"
                    disabled={!hasSearch}
                    loading={isLoading}
                    onClick={submitForm}
                >
                    下发相机标定结果
                </Button>
            </div>
        </Form>
    </div>
};

export default CameraYzyForm;